export class SetRelevantSample {
    static type = '[Sample] Set Relevant Sample';
    
    constructor(public payload: { hash: string; type: string; count?: number; clear?: boolean}) {}
}

export class LoadSampleInfoIntoState {
    static type = '[Sample] Get Sample Count';
    
    constructor() {}
}
export class GetSampleCountSuccess {
    static type = '[Sample] Get Sample Count Success';
    
    constructor(public payload: { count: number;}) {}
}
export class GetSampleCountFail {
    static type = '[Sample] Get Sample Count Fail';
    
    constructor(public payload: { status: number; message: string;}) {}
}

export class StoreSampleCount {
    static type = '[Sample] Store Sample Count';
    
    constructor(public payload: { hash: string, count: number;}) {}
}

export class StoreSampleProgress {
    static type = '[Sample] Store Sample Progress';

    constructor(public payload: { hash: string, progress: number | null }) {}
}